export default __webpack_public_path__ + "static/media/noun-profile@3x.9c0953e7.png";